export { default } from './custom-spinner';
